import ReleaseList from "../components/ReleaseList";

const ListReleasePage = () => {
  return (
    <ReleaseList />
  );
};

export default ListReleasePage;
